import { mediaCards } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-cinema-bg">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">精彩推荐</h2>
          <p className="text-sm text-cinema-muted">预告片 · 花絮 · 名场面精选</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaCards.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-cinema-card hover:bg-cinema-card-hover border border-cinema-border hover:border-cinema-gold/20 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.coverUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-cinema-gold/90 group-hover:bg-cinema-gold transition-colors shadow-lg">
                    <i className="ri-play-fill text-2xl text-cinema-bg ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-cinema-bg/80 text-white text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-white group-hover:text-cinema-gold transition-colors mb-2 line-clamp-1">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-cinema-muted">
                  <span className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </div>
                    {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}